/**
 * Default HTTP client timeouts for API calls (axios). Override with NEXT_PUBLIC_API_TIMEOUT_MS (milliseconds).
 * Auth uses a shorter timeout so failed logins fail fast (see services/auth.ts).
 */
const parsed = Number(process.env.NEXT_PUBLIC_API_TIMEOUT_MS);
export const DEFAULT_API_TIMEOUT_MS =
  Number.isFinite(parsed) && parsed > 0 ? parsed : 30_000;

export const AUTH_REQUEST_TIMEOUT_MS = 15_000;
